import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'ws-ace-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class AceTabsComponent {
    @Output() tabActivated: EventEmitter<string> = new EventEmitter<string>();
}
